import { render } from "./research-group-form-view.vue?vue&type=template&id=35f02acd&ts=true"
import script from "./research-group-form-view.vue?vue&type=script&lang=ts"
export * from "./research-group-form-view.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__